import styled, { css, FlattenSimpleInterpolation } from 'styled-components';

export const StyledMachineOperatingHoursDashboardChartElement = styled.div`
  ${({ theme: { kcc } }): FlattenSimpleInterpolation => css`
    display: contents;

    .machine-operating-hours-dashboard-chart-element__name {
      white-space: nowrap;
      justify-self: flex-start;

      span {
        max-width: 80px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .machine-operating-hours-dashboard-chart-element__bar {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    .machine-operating-hours-dashboard-chart-element__operating-hours {
      white-space: nowrap;
      color: ${kcc.colors.TEXT};
      font-size: ${kcc.typography.FONT_SIZE.SM}px;
      font-weight: ${kcc.typography.FONT_WEIGHT.EXTRA_BOLD};
      line-height: ${kcc.typography.LINE_HEIGHT.BASE};
      justify-self: flex-end;
    }

    .machine-operating-hours-dashboard-chart-element__button--no-styling {
      padding: 0;
      margin: 0;
      height: unset;
      border: unset;
      font-size: ${kcc.typography.FONT_SIZE.SM}px;
      font-weight: ${kcc.typography.FONT_WEIGHT.REGULAR};
      line-height: ${kcc.typography.LINE_HEIGHT.BASE};
    }
  `}
`;
